import { Stack } from '@mui/material';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import type { SyntheticEvent } from 'react';

import { useScreenSize } from '@/hooks/useScreenSize';

interface SectionTabsProps {
  tabs: string[];
  value: number;
  onChange: (index: number) => void;
}

export function SectionTabs({ tabs, value, onChange }: SectionTabsProps) {
  const { isDesktop } = useScreenSize();

  return (
    <Stack alignItems="flex-start" display="flex" justifyContent="flex-start" overflow={!isDesktop ? 'auto' : 'hidden'}>
      <Tabs
        allowScrollButtonsMobile={!isDesktop}
        orientation={isDesktop ? 'vertical' : 'horizontal'}
        scrollButtons={!isDesktop}
        value={value}
        variant={!isDesktop ? 'scrollable' : 'standard'}
        onChange={(_event: SyntheticEvent, newValue: number) => {
          onChange(newValue);
        }}
        sx={{
          '.MuiTab-root': {
            ...(isDesktop && { pr: { l: 3 } }),
            alignItems: 'flex-start',
            textAlign: 'left',
          },
        }}
      >
        {tabs.map((label) => (
          <Tab key={label} label={label} />
        ))}
      </Tabs>
    </Stack>
  );
}
